import { DOCUMENT_FORMATS } from "./documentFormats";

export function getMaskDimensions(
  documentType: string,
  canvasWidth: number,
  canvasHeight: number,
  formatValue: string | null
) {
  const formats = DOCUMENT_FORMATS[documentType];
  if (!formats || formats.length === 0) {
    const maskWidth = canvasWidth * 0.9;
    const maskHeight = canvasHeight * 0.9;
    return {
      maskX: (canvasWidth - maskWidth) / 2,
      maskY: (canvasHeight - maskHeight) / 2,
      maskWidth,
      maskHeight,
    };
  }

  const format = formats.find((f) => f.value === formatValue) || formats[0];
  const ratio = format.ratio;

  const maxW = canvasWidth * 0.9;
  const maxH = canvasHeight * 0.9;

  let maskWidth = maxW;
  let maskHeight = maskWidth / ratio;

  if (maskHeight > maxH) {
    maskHeight = maxH;
    maskWidth = maskHeight * ratio;
  }

  const maskX = (canvasWidth - maskWidth) / 2;
  const maskY = (canvasHeight - maskHeight) / 2;

  return { maskX, maskY, maskWidth, maskHeight };
}
